module.exports = __webpack_public_path__ + "assets/images/skincolor-02.adc2d2b874d213dd90064509d4424352.svg";